// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"190":"779f33ac6bce80942d00","245":"f46e8fee041e61a44e30"}[chunkId] + ".js";
};